export default __webpack_public_path__ + "static/media/warning--camera--g1.97e5cab0.png";